module.exports = __webpack_public_path__ + "static/media/footer_UCTransforma_COR.3699152b.png";